import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.2 7a6 7 0 1 0 0 10","key":"svg-0"}],["path",{"d":"M13 10h-8m0 4h8","key":"svg-1"}]]

/**
 * IconCurrencyEuro
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktZXVybyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTcuMiA3YTYgNyAwIDEgMCAwIDEwIiAvPgogIDxwYXRoIGQ9Ik0xMyAxMGgtOG0wIDRoOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-euro
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyEuro = createReactComponent('outline', 'currency-euro', 'CurrencyEuro', __iconNode);

export default IconCurrencyEuro;